import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9931e350"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "information d-flex flex-column"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "text-size-16 text-weight-500" }
const _hoisted_4 = { class: "updated-at text-size-14 text-mild text-weight-500 mt-2" }
const _hoisted_5 = { class: "text flex-grow-1 mt-2" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, { ref: "header" }, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode(" " + _toDisplayString(_ctx.headerTitle), 1)
      ], undefined, true),
      _: 1
    }, 512),
    _createTextVNode(),
    (_ctx.information)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.information.title), 1),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.informationUpdatedAt), 1)
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", {
              class: "text-size-14",
              innerHTML: _ctx.linkifyText(_ctx.information.text)
            }, null, 8, _hoisted_6)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}